module.exports = __webpack_public_path__ + "static/media/talk-to-customers.80ad44af.png";